/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";

import "../Styles/ofislerimiz.css";
import {
  CheckCircle,
  User,
  Mail,
  CreditCard,
  Calendar,
  Home,
  Download,
  ArrowRight,
} from "lucide-react";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    let [searchParams] = useSearchParams();
    return <Component {...props} router={{ navigate, params, searchParams }} />;
  }

  return ComponentWithRouterProp;
}

class PaymentSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentData: {
        user: "",
        email: "",
        id: "",
        payment: "",
        amount: "",
        transactionId: "",
        date: new Date().toLocaleDateString("tr-TR"),
      },
    };
  }

  componentDidMount() {
    const searchParams = this.props.router.searchParams;

    const transactionId = searchParams.get("id");
    const displayId = searchParams.get("displayId"); 

    this.setState({
      paymentData: {
        user: decodeURIComponent(searchParams.get("user") || "Kullanıcı"),
        email: decodeURIComponent(searchParams.get("email") || ""),
        id: searchParams.get("id") || "",
        payment: searchParams.get("payment") || "success",
        amount: searchParams.get("amount") || "350",
        transactionId: displayId || transactionId || "",
        internalTransactionId: transactionId || "", 
        date: new Date().toLocaleDateString("tr-TR"),
      },
    });

    setTimeout(() => {
      this.showConfetti();
    }, 500);
  }

  showConfetti = () => {
    const confettiContainer = document.createElement("div");
    confettiContainer.style.position = "fixed";
    confettiContainer.style.top = "0";
    confettiContainer.style.left = "0";
    confettiContainer.style.width = "100%";
    confettiContainer.style.height = "100%";
    confettiContainer.style.pointerEvents = "none";
    confettiContainer.style.zIndex = "9999";

    document.body.appendChild(confettiContainer);

    for (let i = 0; i < 50; i++) {
      const confetti = document.createElement("div");
      confetti.style.position = "absolute";
      confetti.style.width = "10px";
      confetti.style.height = "10px";
      confetti.style.backgroundColor = [
        "#ff6b6b",
        "#4ecdc4",
        "#45b7d1",
        "#96ceb4",
        "#feca57",
      ][Math.floor(Math.random() * 5)];
      confetti.style.left = Math.random() * 100 + "%";
      confetti.style.animationDuration = Math.random() * 3 + 2 + "s";
      confetti.style.animationName = "confetti-fall";
      confetti.style.animationTimingFunction = "linear";
      confetti.style.animationFillMode = "forwards";

      confettiContainer.appendChild(confetti);
    }

    const style = document.createElement("style");
    style.textContent = `
      @keyframes confetti-fall {
        0% {
          transform: translateY(-100vh) rotate(0deg);
          opacity: 1;
        }
        100% {
          transform: translateY(100vh) rotate(720deg);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);

    setTimeout(() => {
      document.body.removeChild(confettiContainer);
      document.head.removeChild(style);
    }, 5000);
  };

  handleGoToHome = () => {
    this.props.router.navigate("/");
  };

  handleGoToLogin = () => {
    this.props.router.navigate("/login");
  };

  render() {
    const { paymentData } = this.state;

    return (
      <>
        <Loader />
        <SubHeader />
        <Header
          isLoggedIn={Cookies.get("token") == null ? false : true}
          userName="Mehmet Özkan"
        />

        <div className="offices-container">
          <div
            className="offices-header"
            style={{
              background: "linear-gradient(135deg, #4CAF50 0%, #45a049 100%)",
            }}
          >
            <div className="offices-header-pattern" />

            <div className="container offices-header-container">
              <div className="row">
                <div className="text-center">
                  <div style={{ marginBottom: "20px" }}>
                    <CheckCircle size={80} color="white" />
                  </div>
                  <h6 className="offices-header-subtitle">ÖDEME BAŞARILI</h6>
                  <h1 className="offices-header-title">
                    Ödemeniz Başarıyla Tamamlandı!
                  </h1>
                  <p className="offices-header-description">
                    Sayın {paymentData.user}, ödemeniz başarıyla
                    gerçekleştirildi. İşlem detaylarınızı aşağıda
                    görebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="offices-grid">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div
                    className="office-card universal-card universal-shimmer"
                    style={{ marginBottom: "40px" }}
                  >
                    <div className="office-card-pattern universal-pattern" />

                    <div
                      className="office-card-content"
                      style={{ padding: "40px" }}
                    >
                      <div
                        className="text-center"
                        style={{ marginBottom: "30px" }}
                      >
                        <div
                          style={{
                            background: "#4CAF50",
                            borderRadius: "50%",
                            width: "100px",
                            height: "100px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                          }}
                        >
                          <CheckCircle size={50} color="white" />
                        </div>
                        <h2 style={{ color: "#4CAF50", marginBottom: "10px" }}>
                          Ödeme Başarılı!
                        </h2>
                        <p style={{ color: "#666", fontSize: "16px" }}>
                          İşlem ID: <strong>{paymentData.transactionId}</strong>
                        </p>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className="office-info-card universal-card universal-shimmer"
                            style={{
                              marginBottom: "20px",
                              background: "#f8f9fa",
                            }}
                          >
                            <div
                              className="office-info-card-content"
                              style={{ padding: "20px" }}
                            >
                              <h4
                                style={{
                                  color: "#333",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                Kullanıcı Bilgileri
                              </h4>
                              <div style={{ marginBottom: "10px" }}>
                                <strong>Ad Soyad:</strong> {paymentData.user}
                              </div>
                              <div
                                style={{
                                  marginBottom: "10px",
                                  display: "flex",
                                  alignItems: "flex-start", 
                                  gap: "5px", 
                                }}
                              >
                                
                                <div style={{ 
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word",
                                  wordBreak: "break-word",
                                  hyphens: "auto",
                                  minWidth: 0, 
                                  flex: 1 
                                }}>
                                  <strong>E-posta:</strong> {paymentData.email}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div
                            className="office-info-card universal-card universal-shimmer"
                            style={{
                              marginBottom: "20px",
                              background: "#f8f9fa",
                            }}
                          >
                            <div
                              className="office-info-card-content"
                              style={{ padding: "20px" }}
                            >
                              <h4
                                style={{
                                  color: "#333",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                
                                İşlem Bilgileri
                              </h4>
                              <div style={{ marginBottom: "10px" }}>
                                <strong>İşlem ID:</strong>{" "}
                                {paymentData.transactionId}
                              </div>
                              <div
                                style={{
                                  marginBottom: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                               
                                <strong>Tarih:</strong> {paymentData.date}
                              </div>
                              <div>
                                <strong>Durum:</strong>
                                <span
                                  style={{
                                    color: "#4CAF50",
                                    marginLeft: "5px",
                                  }}
                                >
                                  ✅ Başarılı
                                </span>
                              </div>
                              <div style={{ marginTop: "10px" }}>
                                <strong>Tutar:</strong> {paymentData.amount} TL
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="office-warning-card universal-card universal-shimmer"
                        style={{
                          background: "#e8f5e8",
                          border: "1px solid #4CAF50",
                        }}
                      >
                        <div
                          className="office-warning-card-content"
                          style={{ padding: "20px" }}
                        >
                          <h4
                            style={{ color: "#4CAF50", marginBottom: "10px" }}
                          >
                            Tebrikler!
                          </h4>
                          <p style={{ color: "#333", marginBottom: "15px" }}>
                            Ödemeniz başarıyla gerçekleştirildi. Artık sisteme
                            giriş yapabilir ve mobil uygulamamızı kullanmaya
                            başlayabilirsiniz.
                          </p>
                          <p
                            style={{
                              color: "#333",
                              marginBottom: "0",
                              fontSize: "14px",
                            }}
                          >
                            Herhangi bir sorunuz varsa lütfen bizimle iletişime
                            geçin.
                          </p>
                        </div>
                      </div>

                      <div
                        className="text-center"
                        style={{ marginTop: "30px" }}
                      >
                        <div className="row">
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "15px" }}
                          >
                            <button
                              onClick={this.handleGoToLogin}
                              style={{
                                width: "100%",
                                background:
                                  "linear-gradient(135deg, #4CAF50 0%, #45a049 100%)",
                                color: "white",
                                border: "none",
                                padding: "15px 30px",
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 4px 15px rgba(76, 175, 80, 0.3)",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.transform = "translateY(-2px)";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.transform = "translateY(0px)";
                              }}
                            >
                              <ArrowRight
                                size={20}
                                style={{ marginRight: "10px" }}
                              />
                              Giriş Yap
                            </button>
                          </div>
                          <div className="col-md-6">
                            <button
                              onClick={this.handleGoToHome}
                              style={{
                                width: "100%",
                                background: "none",
                                border: "2px solid #4CAF50",
                                color: "#4CAF50",
                                padding: "15px 30px",
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.background = "#4CAF50";
                                e.target.style.color = "white";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.background = "none";
                                e.target.style.color = "#4CAF50";
                              }}
                            >
                              <Home size={20} style={{ marginRight: "10px" }} />
                              Ana Sayfa
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default withRouter(PaymentSuccess);
